import { render, staticRenderFns } from "./dragpicture1.vue?vue&type=template&id=1ffb7d04&scoped=true"
import script from "./dragpicture1.vue?vue&type=script&lang=js"
export * from "./dragpicture1.vue?vue&type=script&lang=js"
import style0 from "./dragpicture1.vue?vue&type=style&index=0&id=1ffb7d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb7d04",
  null
  
)

export default component.exports